import axios from '../axios.js'
import qs from 'qs';
export let util = {
	/**
	 * 时间格式化
	 * @param string fmt 日期格式
	 * @param string date 日期
	 */
	dateFormat: function(date,fmt) {
		var o = {
			"M+": date.getMonth() + 1, //月份
			"d+": date.getDate(), //日
			"h+": date.getHours(), //小时
			"m+": date.getMinutes(), //分
			"s+": date.getSeconds(), //秒
			"q+": Math.floor((date.getMonth() + 3) / 3), //季度
			"S": date.getMilliseconds() //毫秒
		};
		if(/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
		for(var k in o)
			if(new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		return fmt;
	},
	/**
	 * 处理浮点数相加.保留2位小数
	 * @param {Object} num
	 */
	toDecimal(num) {
		var val = Number(num)
		if(!isNaN(parseFloat(val))) {
			val = val.toFixed(2);
		}
		return Number(val);
	},
	
}
// const baseUrl = 'http://xiaomi.sootoken.com.cn/';
// export const baseUrl = 'http://xiaomi.sootoken.com.cn/';
// export const baseUrl = 'http://wzh.imwap.cn/showcsm/';
// export const baseUrl = 'http://192.168.1.24:8082/';
export let httpRequest={
	/**
	 * 工具内方法 
	 * @param {Object} url 请求地址
	 * @param {Object} params 参数
	 * @param {Object} showLoading 是否显示加载提示
	 * @param {Object} callBack 回调函数
	 * @param {Object} method 请求方法/方式 (GET POST)
	 */
	request(url,params,showLoading,method,callBack){
		// var token = "";
		// const userInfo = uni.getStorageSync('user');
		// const token = uni.getStorageSync('token');
		// if (userInfo) {
		// 	token = token;
		// 	deviceInfo.userId=userInfo.id;
		// }
		// if(showLoading){
		// 	uni.showLoading({
		// 		title:"加载中"
		// 	})
		// }
		console.log(url,params,showLoading,method,qs.stringify(params));
		axios({
		  // url: baseUrl + url,
		  url: url,
		  method: method,
		  // data: qs.stringify(params),
		  data: params,
		  headers: {
		  	"Content-Type": "application/x-www-form-urlencoded",
		  }
		}).then((res) => {
			callBack(res)
		}).catch((error)=>{
			console.log(error);
		});
		// axios({
		// 	url: url, 
		// 	method:method,
		// 	data:qs.stringify(params),
		// 	success: (res) => {
		// 		// if (res.statusCode === 500) {
		// 		// 	util.tips("服务异常，请稍后再试")
		// 		// }else if (res.statusCode === 403) {
		// 		// 	util.tips("登录过期，请重新登录")
		// 		// }else if (res.statusCode === 404) {
		// 		// 	util.tips("网络请求不存在")
		// 		// }
		// 		callBack(res)
		// 	},
		// 	fail(e) {
		// 		util.tips("请求失败： 请稍后再试");
		// 	},
		// 	complete(e) {
		// 		if(showLoading){
		// 			uni.hideLoading()
		// 		}
		// 	}
		// });
	},
	uploadFile(url,file,showLoading,callBack){
		let fd = new FormData();
		fd.append('file', file);
		axios({
		   url: url,
		   method: 'POST',
		   data: fd,
		   headers: {
				'Content-Type': 'multipart/form-data'
		   }
		 }).then((res) => {
		 	callBack(res)
		 }).catch((error)=>{
		 	console.log(error);
		 });
	}
}

// export default {httpRequest,baseUrl,util};


// WEBPACK FOOTER //
// ./src/common/js/util.js